import { Control } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { Input } from "../ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

interface CustomInput {
  control?: Control<any>;
  name: string;
  label: string;
  placeholder?: string;
  type?: string;
  className?: string;
  onChange?: (value: string) => void;
  options?: Array<{ label: string; value: string }> | string[];
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}
const CustomInput = ({
  control,
  name,
  label,
  placeholder,
  type = "text",
  className,
  onChange,
  options,
  disabled,
  onClick,
}: CustomInput) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <div className="form-item">
          <FormLabel className="form-label">{label}</FormLabel>
          <div className="flex w-full flex-col">
            <FormControl>
              {type === "radio" && options ? (
                <RadioGroup
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  className={className}
                  disabled={disabled}
                >
                  {options.map((option) => (
                    <FormItem
                      key={typeof option === "string" ? option : option.value}
                      className="flex items-center space-x-3 space-y-0"
                    >
                      <FormControl>
                        <RadioGroupItem
                          value={
                            typeof option === "string" ? option : option.value
                          }
                        />
                      </FormControl>
                      <FormLabel className="font-normal">
                        {typeof option === "string" ? option : option.label}
                      </FormLabel>
                    </FormItem>
                  ))}
                </RadioGroup>
              ) : type === "select" && options ? (
                <Select
                  onValueChange={(value) => {
                    field.onChange(value);
                    if (onChange) {
                      onChange(value);
                    }
                  }}
                  defaultValue={field.value as string}
                  disabled={disabled}
                >
                  <FormControl>
                    <SelectTrigger onClick={onClick}>
                      <SelectValue placeholder={placeholder} />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    {options.map((option) => (
                      // @ts-ignore
                      <SelectItem key={option} value={option}>
                        {/* @ts-ignore */}
                        {option}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <Input
                  {...field}
                  value={
                    field.value instanceof Date
                      ? field.value.toISOString().split("T")[0]
                      : typeof field.value === "string"
                      ? field.value
                      : field.value || ""
                  }
                  placeholder={placeholder}
                  className={className}
                  type={type}
                  disabled={disabled}
                  onChange={(e) => {
                    const value =
                      type === "number"
                        ? parseFloat(e.target.value)
                        : e.target.value;
                    field.onChange(value);
                    if (onChange) {
                      onChange(e.target.value);
                    }
                  }}
                  // onClick={onClick}
                />
              )}
            </FormControl>
            <FormMessage className="form-message mt-2" />
          </div>
        </div>
      )}
    />
  );
};

export default CustomInput;
